import { includes } from 'lodash'
import React, { Reducer, useCallback, useEffect, useReducer } from 'react'
import { Form, Header, Transition } from 'semantic-ui-react'
import { v4 as uuid } from 'uuid'
import ClosingListItem from './components/ClosingListItem'
import { ANIMATION_DURATION, SpecialInstructionOptions } from './constants'
import styles from './styles.module.less'
import { SpecialInstruction, TradeFormValues } from './Types'

export interface SpecialInstructionsProps {
  values: TradeFormValues
  setFieldValue: (field: string, value: any, shouldValidate?: boolean | undefined) => void
}

type instructionAction = {
  type: 'ADD' | 'REMOVE' | 'UPDATE'
  id?: string
  value?: any
}

export const reducer: Reducer<SpecialInstruction[], instructionAction> = (
  state: SpecialInstruction[],
  action: instructionAction
) => {
  switch (action.type) {
    case 'ADD':
      if (state.length >= 5) {
        return state
      }
      return [...state, { id: uuid() }]
    case 'REMOVE':
      return state.filter(item => item.id !== action.id)
    case 'UPDATE':
      return state.map(item => {
        if (item.id === action.id) {
          return { ...item, value: action.value }
        }
        return item
      })
    default:
      return state
  }
}

const SpecialInstructions = ({ values: { specialInstructions }, setFieldValue }: SpecialInstructionsProps) => {
  const [instructionsList, dispatch] = useReducer(reducer, specialInstructions || [])
  const setFieldValueMemoized = useCallback(setFieldValue, [])
  useEffect(() => {
    setFieldValueMemoized('specialInstructions', instructionsList)
  }, [instructionsList, setFieldValueMemoized])
  const chosenInstructions = specialInstructions?.map(instruction => instruction.value) || []
  return (
    <>
      <Header as={'h3'}>Special Instructions</Header>
      <p>Add up to five special instructions items.</p>
      <Transition.Group animation={'fade down'} duration={ANIMATION_DURATION}>
        {specialInstructions?.map(({ id, value }: SpecialInstruction, index) => {
          return (
            <div key={id}>
              <ClosingListItem onClose={() => dispatch({ type: 'REMOVE', id })} showRemoveButton>
                <Form.Select
                  className={'test-special-instruction'}
                  selection
                  search
                  label={'Special Instruction'}
                  name="specialInstruction"
                  value={value}
                  options={SpecialInstructionOptions.filter(
                    option => option.value === value || !includes(chosenInstructions, option.value)
                  )}
                  onChange={(_, data) => {
                    dispatch({ type: 'UPDATE', value: data.value, id })
                  }}
                />
              </ClosingListItem>
            </div>
          )
        })}
        {specialInstructions && specialInstructions.length < 5 && (
          <div className={styles.addItemButtonWrap}>
            <button
              onClick={() => dispatch({ type: 'ADD' })}
              className={`${styles.btnLink} test-add-spec-ins`}
              type={'button'}
            >
              + Add Item
            </button>
          </div>
        )}
      </Transition.Group>
    </>
  )
}

export default SpecialInstructions
